import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface SurveyAnimationState {
  hasAnimatedSummary: { [key: string]: boolean };
  hasShownComplete: { [key: string]: boolean };
}

export const defaultSurveyAnimationState: SurveyAnimationState = {
  hasAnimatedSummary: {},
  hasShownComplete: {},
};

export const surveyAnimationSlice = createSlice({
  initialState: defaultSurveyAnimationState,
  name: 'surveyAnimationState',
  reducers: {
    clearSurveyAnimationState(state) {
      state.hasAnimatedSummary = { ...defaultSurveyAnimationState.hasAnimatedSummary };
    },
    setSummaryAnimated(state, { payload }: PayloadAction<{ surveyId: string }>) {
      if (!state.hasAnimatedSummary) {
        state.hasAnimatedSummary = {};
      }

      state.hasAnimatedSummary[payload.surveyId] = true;
    },
    clearSurveyCompleteState(state) {
      state.hasShownComplete = { ...defaultSurveyAnimationState.hasShownComplete };
    },
    setShownComplete(state, { payload }: PayloadAction<{ surveyId: string }>) {
      if (!state.hasShownComplete) {
        state.hasShownComplete = {};
      }

      state.hasShownComplete[payload.surveyId] = true;
    },
  },
});

export const {
  clearSurveyAnimationState,
  setSummaryAnimated,
  clearSurveyCompleteState,
  setShownComplete,
} = surveyAnimationSlice.actions;

export default surveyAnimationSlice.reducer;
